import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Invite-Only Lounge | Member Services | FGA Prestige',
  description: 'Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations.',
  openGraph: {
    title: 'Invite-Only Lounge | Member Services | FGA Prestige',
    description: 'Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations.',
    url: 'https://fgaprestige.com/member-services/invite-only-lounge',
    images: [
      {
        url: '/Member Services/Invite-Only Lounge/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Invite-Only Lounge',
      },
    ],
  },
}

const inviteOnlyLoungeConfig: ServicePageConfig = {
  title: 'Invite-Only Lounge - FGA Prestige',
  description: 'Exclusive private club access in premier locations worldwide.',
  slug: 'invite-only-lounge',
  heroImage: '/Member Services/Invite-Only Lounge/hero.png',
  serviceName: 'INVITE-ONLY LOUNGE',
  whySectionA: {
    title: 'Where Exclusivity Finds Elevation',
    content: 'Private Lounge, 19/F Queens Road Centre\n\nLuxury reimagined—far above the bustle, our private lounge invites you into an oasis crafted for comfort, conversation, and possibility. Here, sunlight filters through expansive windows, illuminating plush interiors and handpicked accents that speak to refined taste.',
    image: '/Member Services/Invite-Only Lounge/body/1.png',
    imageAlt: 'Exclusive Lounge Environment'
  },
  whySectionC: {
    title: 'A Sanctuary for Connection',
    content: 'Imagine unhurried afternoons sipping curated cocktails, or intimate gatherings where every detail—from bespoke service to exquisite art—creates an atmosphere designed for both relaxation and inspiration. Your time is your own, and our lounge is your canvas.',
    image: '/Member Services/Invite-Only Lounge/body/2.png',
    imageAlt: 'Exclusive Lounge Environment'
  },
  whySectionB: {
    title: 'Your Invitation to the Exceptional',
    benefits: [
      {
        title: '',
        description: 'This is more than a destination; it’s an experience tailored for those who appreciate subtle elegance and meaningful moments. Whether meeting collaborators or simply escaping the pace of Central, discover a space where privacy, sophistication, and hospitality are always yours.'
      }
    ],
    image: '/Member Services/Invite-Only Lounge/body/3.png',
    imageAlt: 'Premium Lounge Facilities'
  },
  masterpieceBackgroundImage: '/Member Services/Invite-Only Lounge/CTA Banner/banner.png'
}

export default function InviteOnlyLoungePage() {
  return (
    <>
      <Helmet>
        <title>Invite-Only Lounge | Member Services | FGA Prestige</title>
        <meta name="description" content="Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/invite-only-lounge" />
        <meta property="og:title" content="Invite-Only Lounge | Member Services | FGA Prestige" />
        <meta property="og:description" content="Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/invite-only-lounge" />
        <meta property="og:image" content="/Member Services/Invite-Only Lounge/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Invite-Only Lounge" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Invite-Only Lounge | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations." />
        <meta name="twitter:image" content="/Member Services/Invite-Only Lounge/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Invite-Only Lounge",
            "description": "Exclusive private club access worldwide. Members-only lounges for privacy, networking, and relaxation in premier global locations.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/invite-only-lounge",
            "image": "/Member Services/Invite-Only Lounge/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={inviteOnlyLoungeConfig} />
    </>
  )
}